import { Box, Typography } from '@mui/material';
import Lock from './Lock.svg';

export function OnlyMemberComponent() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        columnGap: 1,
      }}
    >
      <Box
        component="img"
        src={Lock.src}
        width={20}
        height={20}
        sx={{
          width: '20px',
          height: '20px',
        }}
      />
      <Typography
        variant="JP/Body/m/Regular/Normal"
        sx={{
          color: '#FF8E00',
        }}
      >
        会員限定の情報です
      </Typography>
    </Box>
  );
}
